import React, { useContext, useEffect, useRef, useState } from 'react'
import NewsBackground from '../../../assets/backgrounds/news.svg'
import { Color, Direction } from '../../../utils/constants'
import { FormattedMessage } from 'react-intl'
import Button from '../../../components/Button/Button'
import { getCategoryPosts, getResourceCategories } from '../../../utils/api'
import PostSummary from '../../../partials/Post/PostSummary'
import { Link } from '../../../utils/helpers'
import { WP_REST_API_Post } from 'wp-types/index'
import ArrowNavigation from '../../../components/ArrowNavigation'
import HorizontalScroll from '../../../components/HorizontalScroll'
import MovingBackground from '../../../partials/MovingBackground/MovingBackground'
import SectionWithTag, { Side } from '../../../components/SectionWithTag'
import PaddingContext from '../../../utils/PaddingContext'
import ScrollBar from '../../../components/ScrollBar'

const News = () => {
    const { padding } = useContext(PaddingContext)

    const [categories, setCategories] = useState<any[]>([])
    const [posts, setPosts] = useState<WP_REST_API_Post[]>([])
    useEffect(() => {
        getResourceCategories(setCategories)
    }, [])

    useEffect(() => {
        getCategoryPosts(setPosts, categories, 7)
    }, [categories])

    const scrollRef = useRef<HTMLDivElement>(null)

    return (
        <div className='bg-black relative'>
            <MovingBackground component={NewsBackground}>
                <div className='py-14 md:py-30 relative pr-0'>
                    <SectionWithTag
                        tag={{ id: 'section.news', color: Color.WHITE }}
                        side={Side.LEFT}
                        padding={padding}
                        className='3xl:max-w-screen-2xl mx-auto'
                        contentClasses='block'
                    >
                        <div className='text-white'>
                            <div className='flex justify-between items-center md:pr-24 pt-9 md:pt-0'>
                                <FormattedMessage id='section.news.title' tagName='h2' />
                                <div className='hidden md:block'>
                                    <ArrowNavigation scrollRef={scrollRef} />
                                </div>
                            </div>
                            <HorizontalScroll wrapperClasses='py-12 gap-x-5 pr-24' ref={scrollRef}>
                                {posts.map((post: WP_REST_API_Post) => (
                                    <PostSummary
                                        post={post}
                                        key={`post-${post.id}`}
                                        className='news__post'
                                        addGradient={false}
                                    />
                                ))}
                            </HorizontalScroll>
                            <div className='md:mr-24 pb-12'>
                                <ScrollBar scrollRef={scrollRef} isVertical={false} color={Color.WHITE} />
                            </div>
                        </div>
                    </SectionWithTag>
                    <div className='flex justify-center relative'>
                        <Link to='resources'>
                            <Button
                                buttonColor={Color.WHITE}
                                isInverted
                                chevron={Direction.RIGHT}
                                outerClasses='w-full md:w-max'
                            >
                                <FormattedMessage id={'button.viewAllNews'} tagName='h6' />
                            </Button>
                        </Link>
                    </div>
                </div>
            </MovingBackground>
        </div>
    )
}

export default News
